import decoder from '../../../lib/decoder';
import ModelCart from './cart'

function ModelCartItem() {
	this.type = '';
	this.id = 0;
	this.productId = 0;
	this.name = '';
	this.priceOnce = 0;
	this.priceOnceFull = 0;
	this.priceMonthly = 0;
	this.priceMonthlyFull = 0;
	this.numberId = 0;
	this.providerId = 0;
	this.tariffId = 0;
	this.branchId = 0;
}

ModelCartItem.create = function (json, type) {
	let model = new ModelCartItem();
	model.type = type;
	
	switch (type) {
		case ModelCart.constants.type.mgp: {
			model.id = Math.round(Math.random() * 1e6);
			model.name = json;
			break;
		}
		case ModelCart.constants.type.portingNumbers: {
			if (!json) json = {};
			model.id = decoder.intValue(json['id'], 0);
			model.name = decoder.stringValue(json['number'], '');
			if (model.name) {
				model.name = '+' + model.name;
			}
			break;
		}
		default: {
			if (!json) json = {};
			model.id = decoder.intValue(json['ID'], 0);
			model.productId = decoder.intValue(json['PRODUCT_ID'], 0);
			model.name = decoder.stringValue(json['NAME'], '');
			model.priceOnce = decoder.floatValue(json['PRICE_ONCE'], 0);
			model.priceOnceFull = decoder.floatValue(json['PRICE_ONCE_FULL'], 0);
			model.priceMonthly = decoder.floatValue(json['PRICE_MONTHLY'], 0);
			model.priceMonthlyFull = decoder.floatValue(json['PRICE_MONTHLY_FULL'], 0);
			
			if (type === ModelCart.constants.type.vats) {
				// Для ВАТС Разовый платеж (PRICE_ONCE) - это ежемесячный МГМ
				model.priceMonthlyFull += model.priceOnce;
				model.priceMonthly += model.priceOnce;
				model.priceOnce = 0;
				model.priceOnceFull = 0;
			} else if (type === ModelCart.constants.type.tariffs) {
				model.providerId = decoder.intValue(json['PROVIDER'], 0);
				model.tariffId = decoder.intValue(json['XML_ID'], 0);
			} else if (type === ModelCart.constants.type.numbers || type === ModelCart.constants.type.fmcNumbers || type === ModelCart.constants.type.mvnoNumbers) {
				model.numberId = decoder.intValue(json['NUMBER_ID'], 0);
				model.providerId = decoder.intValue(json['PROVIDER'], 0);
				model.tariffId = decoder.intValue(json['TARIFF_ID'], 0);
				model.branchId = decoder.intValue(json['FILIAL_ID'], 0);
			}
		}
	}
	
	return model;
};

ModelCartItem.createFromPortingNumber = function (number) {
	let model = new ModelCartItem();
	model.type = ModelCart.constants.type.portingNumbers;
	if (number) {
		model.id = decoder.intValue(number.id, 0);
		model.name = decoder.stringValue(number.number, '');
	}
	return model
};

ModelCartItem.createFromNumber = function (number, group, type) {
	let model = new ModelCartItem();
	model.type = type;
	model.id = Math.round(Math.random() * 1e6);
	if (number) {
		model.numberId = number.id;
		model.name = number.formatted;
	}
	if (group) {
		model.branchId = group.branchId;
		if (group.provider) {
			model.providerId = group.provider.id;
		}
		if (group.selectedTariff) {
			model.tariffId = group.selectedTariff.id;
		} else {
			model.tariffId = group.tariffId;
		}
		model.priceOnce = group.priceOnceFull;
		model.priceOnceFull = group.priceOnceFull;
		model.priceMonthly = group.priceMonthlyFull;
		model.priceMonthlyFull = group.priceMonthlyFull;
	}
	return model
};

export default ModelCartItem;